import { render, staticRenderFns } from "./EntryHeaderCard.vue?vue&type=template&id=4c2b8d8b&scoped=true&"
import script from "./EntryHeaderCard.vue?vue&type=script&lang=js&"
export * from "./EntryHeaderCard.vue?vue&type=script&lang=js&"
import style0 from "./EntryHeaderCard.vue?vue&type=style&index=0&id=4c2b8d8b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2b8d8b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nicholashaskell/Local/kicknic/app/public/wp-content/themes/kicknic/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c2b8d8b')) {
      api.createRecord('4c2b8d8b', component.options)
    } else {
      api.reload('4c2b8d8b', component.options)
    }
    module.hot.accept("./EntryHeaderCard.vue?vue&type=template&id=4c2b8d8b&scoped=true&", function () {
      api.rerender('4c2b8d8b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/scripts/components/EntryHeaderCard.vue"
export default component.exports